import React, { useState, useEffect, useCallback } from 'react';
import { FiSearch, FiTrash2, FiRefreshCw, FiRotateCcw, FiFolder, FiArrowLeft } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { tasksAPI } from '../services/api';

const TrashTab = ({ onBack }) => {
    const [deletedTasks, setDeletedTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    const loadTrash = useCallback(async () => {
        try {
            setLoading(true);
            const res = await tasksAPI.getTrash();
            setDeletedTasks(res.data.tasks || []);
        } catch (err) {
            toast.error('Failed to load trash');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadTrash();
    }, [loadTrash]);

    const handleRestore = async (id) => {
        try {
            await tasksAPI.restore(id);
            toast.success('Task restored');
            loadTrash();
        } catch (err) {
            toast.error('Failed to restore task');
        }
    };

    const filteredTasks = deletedTasks.filter(t =>
        (t.title || '').toLowerCase().includes(search.toLowerCase()) ||
        (t.createdBy?.username || '').toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="admin-tab-content standalone-trash">
            <div className="tab-header">
                <div className="header-left">
                    {onBack && (
                        <button className="back-btn-link" onClick={onBack} title="Go Back">
                            <FiArrowLeft size={20} />
                        </button>
                    )}
                    <h2><FiTrash2 size={20} /> Trash</h2>
                    <span className="count-badge">{filteredTasks.length} deleted tasks</span>
                </div>
                <div className="header-actions">
                    <div className="search-box">
                        <FiSearch size={16} />
                        <input
                            placeholder="Search deleted tasks..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                    </div>
                    <button className="refresh-btn" onClick={loadTrash} title="Refresh Trash">
                        <FiRefreshCw size={16} />
                    </button>
                </div>
            </div>

            <div className="trash-list-container">
                {loading ? (
                    <div className="loading-state">Loading trash...</div>
                ) : filteredTasks.length > 0 ? (
                    <div className="trash-grid">
                        {filteredTasks.map(task => (
                            <div key={task._id} className="trash-item">
                                <div className="trash-item-info">
                                    <div className="trash-item-header">
                                        <h3 className="mb-2 text-lg font-semibold">{task.title}</h3>
                                        <span className="trash-item-date">{new Date(task.updatedAt).toLocaleDateString()}</span>
                                    </div>
                                    <p className="trash-item-desc">{task.description?.substring(0, 100)}{task.description?.length > 100 ? '...' : ''}</p>
                                    <div className="trash-item-meta">
                                        <span className="meta-label">Created by: {task.createdBy?.username || 'Unknown'}</span>
                                        {task.projectId && (
                                            <span className="meta-project" style={{ color: task.projectId.color }}>
                                                <FiFolder size={12} /> {task.projectId.name}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <button
                                    className="restore-btn"
                                    onClick={() => handleRestore(task._id)}
                                    title="Restore Task"
                                >
                                    <FiRotateCcw size={14} /> Restore
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="empty-state">
                        <FiTrash2 size={48} />
                        <p>Trash is empty</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TrashTab;
